
export const AssortmentRatingsList: string[] = [
    'A',
    'B',
    'C',
    'D',
    'E'
];
